import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { ACCOUNT_TAB_LABELS, accountTabPath, type AccountTab } from '../account.paths';
import { ProfilePage } from '../features/profile/pages/ProfilePage';
import { SecurityPage } from '../features/security/pages/SecurityPage';

/** The signed-in person's own account. Not an office section, so its trail is just "Account". */
export function AccountPage({ tab }: { tab: AccountTab }) {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader breadcrumbs={[{ label: 'Account' }]} title="Your account" description="Your details, and how you sign in." />
      <Tabs
        activeKey={tab}
        onChange={(key) => navigate(accountTabPath(key as AccountTab))}
        items={[
          { key: 'profile', label: ACCOUNT_TAB_LABELS.profile, children: <ProfilePage /> },
          { key: 'security', label: ACCOUNT_TAB_LABELS.security, children: <SecurityPage /> },
        ]}
      />
    </>
  );
}
